import axios from '@/api/config';

const wxSchoolPageTemplate = {
  getWxSchoolPageTemplateById(data) {
    return axios.get(`${process.env.BASE_URL}/wxSchoolPageTemplate/getWxSchoolPageTemplateById/` + data, {});
  },
  getWxSchoolPageTemplateDetail(data) {
    return axios.get(`${process.env.BASE_URL}/wxSchoolPageTemplate/getWxSchoolPageTemplateDetail`, {params: data});
  },
  getWxSchoolPageTemplate(data) {
    return axios.get(`${process.env.BASE_URL}/wxSchoolPageTemplate/getWxSchoolPageTemplate`, {params: data});
  },
  getWxSchoolPageTemplateList(data) {
    return axios.get(`${process.env.BASE_URL}/wxSchoolPageTemplate/getWxSchoolPageTemplateList`, {params: data});
  },
  getWxSchoolPageTemplateTree(data) {
    return axios.get(`${process.env.BASE_URL}/wxSchoolPageTemplate/getWxSchoolPageTemplateTree`, {params: data});
  },
  pageList(data) {
    return axios.post(`${process.env.BASE_URL}/wxSchoolPageTemplate/pageList`, data);
  },
  addWxSchoolPageTemplate(data) {
    return axios.post(`${process.env.BASE_URL}/wxSchoolPageTemplate/addWxSchoolPageTemplate`, data);
  },
  updateWxSchoolPageTemplate(data) {
    return axios.put(`${process.env.BASE_URL}/wxSchoolPageTemplate/updateWxSchoolPageTemplate`, data);
  },
  deleteWxSchoolPageTemplate(data) {
    return axios.delete(`${process.env.BASE_URL}/wxSchoolPageTemplate/deleteWxSchoolPageTemplate`,  {data: data});
  },
  exportExcel(data) {
    return axios.get(`${process.env.BASE_URL}/wxSchoolPageTemplate/exportExcel`, {params: data});
  },
  importData(data) {
    return axios.post(`${process.env.BASE_URL}/wxSchoolPageTemplate/importData`, data);
  },
  active(data) {
    return axios.post(`${process.env.BASE_URL}/wxSchoolPageTemplate/active`, data);
  },
}

export default wxSchoolPageTemplate;



// WEBPACK FOOTER //
// ./src/api/wxSchoolPageTemplate.js